export default {
  customerGetRateableOrder: async () => {
    return await axios.get('/customer/rate/get-rateable-booking');
  },

  customerRatePlatformOrderBooking: async (order_id, payload) => {
    return await axios.post(`/customer/rate/order/${order_id}`, payload);
  },

  customerRatePlatformOrderDelivery: async (order_id, payload) => {
    return await axios.post(`/customer/rate/delivery/${order_id}`, payload);
  },
}

